export default "__VITE_PUBLIC_ASSET__27aa4389__"